export const LOGIN_ERROR_MESSAGES = [
  {
    message: 'Username is not found.',
    key: 'login_statusMessage_notFound',
  },
  {
    message: 'User is not activated!',
    key: 'login_statusMessage_notActivated',
  },
  {
    message: 'Username and/or password is invalid.',
    key: 'login_statusMessage_invalid',
  },
  {
    message: 'Username, password, and/or OTP is invalid.',
    key: 'login_statusMessage_invalid',
  },
];
